var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.waitingForUpload
        ? [
            _vm.smsEligible
              ? _c("div", [
                  _c("div", [
                    _vm._v(
                      "Wir haben dir eine SMS geschickt, bitte prüfe deine Nachrichten und öffne den darin enthaltenen\n\t\t\t\tLink.\n\t\t\t"
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", [
                    _vm._v("Dort findest du alle weiteren Informationen.")
                  ])
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.qrEligible && _vm.qrCodeBase64
              ? _c(
                  "div",
                  { staticClass: "mt-2 text-center" },
                  [
                    _c("b-img", { attrs: { src: _vm.qrCodeBase64, fluid: "" } })
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "mt-2" },
              [_c("Loading", { attrs: { text: "Warte auf das Dokument" } })],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "mt-2" }, [
              _c(
                "a",
                {
                  attrs: { href: "#" },
                  on: {
                    click: function($event) {
                      $event.preventDefault()
                      return _vm.abort.apply(null, arguments)
                    }
                  }
                },
                [_vm._v("Legitimierung abbrechen")]
              )
            ])
          ]
        : [
            _c(
              "FormGroup",
              {
                attrs: {
                  label:
                    "Bitte wähle aus, welches Dokument du hochladen willst: ",
                  state: _vm.documentTypeValid
                }
              },
              [
                _c("RadioGroup", {
                  attrs: { options: _vm.documentTypeOptions, stacked: "" },
                  on: { input: _vm.emitChangeEvent },
                  model: {
                    value: _vm.documentType,
                    callback: function($$v) {
                      _vm.documentType = $$v
                    },
                    expression: "documentType"
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _vm.documentType
              ? _c(
                  "FormGroup",
                  {
                    staticClass: "mt-3",
                    attrs: {
                      label:
                        "Wie willst du deinen Ausweis hochladen zur Legitimation?",
                      state: _vm.typeValid
                    }
                  },
                  [
                    _c("RadioGroup", {
                      attrs: { options: _vm.typeOptions, stacked: "" },
                      on: { input: _vm.emitChangeEvent },
                      model: {
                        value: _vm.type,
                        callback: function($$v) {
                          _vm.type = $$v
                        },
                        expression: "type"
                      }
                    })
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.type
              ? _c(
                  "div",
                  { staticClass: "mt-2" },
                  [
                    _vm.localEligible
                      ? [
                          _c(
                            "FormGroup",
                            { attrs: { state: _vm.localFileValid } },
                            [
                              _c(
                                "b-row",
                                [
                                  _c(
                                    "b-col",
                                    { attrs: { md: "10" } },
                                    [
                                      _c("FileInput", {
                                        on: { input: _vm.emitChangeEvent },
                                        model: {
                                          value: _vm.localFile,
                                          callback: function($$v) {
                                            _vm.localFile = $$v
                                          },
                                          expression: "localFile"
                                        }
                                      }),
                                      _vm._v(" "),
                                      _vm.localFile
                                        ? _c(
                                            "div",
                                            { staticClass: "mt-3" },
                                            [
                                              _c(
                                                "div",
                                                { staticClass: "color-red" },
                                                [
                                                  _vm._v(
                                                    "Legitimationsbestätigung"
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "FormGroup",
                                                {
                                                  staticClass: "mt-3",
                                                  attrs: {
                                                    label:
                                                      "Die hinaufgeladene Datei enthält einen amtlichen Lichtbildausweis von mir persönlich mit einem einem Foto von meinem eigenen Gesicht:",
                                                    state: _vm.face !== false,
                                                    "invalid-feedback":
                                                      "Bitte verwende ein persönliches Ausweisdokument von dir mit einem Foto von deinem Gesicht.",
                                                    "feedback-beneath": ""
                                                  }
                                                },
                                                [
                                                  _c("RadioGroup", {
                                                    attrs: {
                                                      options: _vm.faceOptions
                                                    },
                                                    on: {
                                                      input: _vm.emitChangeEvent
                                                    },
                                                    model: {
                                                      value: _vm.face,
                                                      callback: function($$v) {
                                                        _vm.face = $$v
                                                      },
                                                      expression: "face"
                                                    }
                                                  })
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "FormGroup",
                                                {
                                                  staticClass: "mt-3",
                                                  attrs: {
                                                    label:
                                                      "Der Text des Ausweises ist gut leserlich und auf dem Foto ist mein Gesicht klar sichtbar:",
                                                    state:
                                                      _vm.clearness !== false,
                                                    "invalid-feedback":
                                                      "Bitte lade ein gut leserliches Ausweisdokument hoch",
                                                    "feedback-beneath": ""
                                                  }
                                                },
                                                [
                                                  _c("RadioGroup", {
                                                    attrs: {
                                                      options:
                                                        _vm.clearnessOptions
                                                    },
                                                    on: {
                                                      input: _vm.emitChangeEvent
                                                    },
                                                    model: {
                                                      value: _vm.clearness,
                                                      callback: function($$v) {
                                                        _vm.clearness = $$v
                                                      },
                                                      expression: "clearness"
                                                    }
                                                  })
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          )
                                        : _vm._e()
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c("b-col", { attrs: { md: "2" } }, [
                                    _vm.localFile
                                      ? _c(
                                          "div",
                                          [
                                            _c("b-img", {
                                              attrs: {
                                                src: _vm.localFile.base64,
                                                fluid: ""
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      : _vm._e()
                                  ])
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ]
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.smsEligible
                      ? [
                          _c(
                            "FormGroup",
                            {
                              attrs: {
                                label: "Mobilnummer",
                                state: _vm.phoneValid
                              }
                            },
                            [
                              _c("Phone", {
                                attrs: { meta: _vm.meta },
                                on: { input: _vm.emitChangeEvent },
                                model: {
                                  value: _vm.phone,
                                  callback: function($$v) {
                                    _vm.phone = $$v
                                  },
                                  expression: "phone"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "mt-2" },
                            [
                              _c("Button", {
                                attrs: {
                                  text: "SMS senden",
                                  disabled: !_vm.phoneValid || _vm.requesting
                                },
                                on: { click: _vm.requestLink }
                              })
                            ],
                            1
                          )
                        ]
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.emailEligible
                      ? [
                          _c(
                            "FormGroup",
                            {
                              attrs: {
                                label: "E-Mail",
                                state: _vm.emailValid,
                                "invalid-feedback": _vm.emailError,
                                "feedback-beneath": ""
                              }
                            },
                            [
                              _c("b-input", {
                                on: { input: _vm.emitChangeEvent },
                                model: {
                                  value: _vm.email,
                                  callback: function($$v) {
                                    _vm.email = $$v
                                  },
                                  expression: "email"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "mt-2" },
                            [
                              _c("Button", {
                                attrs: {
                                  text: "E-Mail senden",
                                  disabled: !_vm.emailValid || _vm.requesting
                                },
                                on: { click: _vm.requestLink }
                              })
                            ],
                            1
                          )
                        ]
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.qrEligible
                      ? [
                          _c("Button", {
                            attrs: {
                              text: "QR-Code erstellen",
                              disabled: _vm.requesting
                            },
                            on: { click: _vm.requestLink }
                          })
                        ]
                      : _vm._e()
                  ],
                  2
                )
              : _vm._e()
          ]
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }